<template>
  <div class="layer layer2">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"></button>
      <h2 class="layerTitle">{{ locale.disabled_mark }}</h2>
      <div class="info">
        <div class="mb15 isRequired">
          <div class="innerTitle setLabel">{{locale.name}}</div>
          <input type="text" class="input" v-model="name">
        </div>
        <div class="isRequired">
          <div class="innerTitle setLabel">{{ locale.text }}</div>
          <SetLanguageValue
            :locale="locale"
            :langValue="text"
            :textarea="true" />
        </div>
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary" :disabled="!isValid" @click="save">{{ locale.save }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LANG from '@/common/lang'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import ColorPicker from '@/components/Util/ColorPicker.vue'
import SetLanguageValue from '@/components/Util/SetLanguageValue'

export default {
  name: 'CompositeStatus',
  props: [
    'locale',
    'presetId'
  ],
  components: {
    ColorPicker,
    SetLanguageValue
  },
  computed: {
    currentLang () {
      return this.$store.getters['getLanguageObj']?.selected || 'ko'
    },
    isValid () {
      const lang = this.currentLang
      const name = regExp.replaceAllEmpty(this.name) !== ''
      const isValidText = regExp.replaceAllEmpty(this.text[lang]) !== ''
      return name && isValidText
    }
  },
  created () {
    if (this.presetId && this.presetId !== 'new') {
      this.getShopPresetDetail()
    }
  },
  data () {
    return {
      name: '',
      text: LANG.valueObj('')
    }
  },
  methods: {
    async getShopPresetDetail () {
      this.$store.commit('onLoading', true)
      const getDetail = await this.$store.dispatch('shop/getShopPresetDetail', {
        presetType: 'status',
        presetId: this.presetId
      })
      const detail = getDetail && getDetail.message
      if (detail && detail.presetId) {
        const status = detail.presetOptions[0]
        this.name = detail.presetName
        this.text = status.text
      }
      this.$store.commit('onLoading', false)
    },
    close () {
      this.$emit('close')
    },
    async save () {
      const presetId = this.presetId && this.presetId !== 'new' && this.presetId
      const data = {
        presetType: 'status',
        presetId: presetId || UNIQUE.uniqueId8(),
        presetName: this.name,
        presetOptions: [{
          id: UNIQUE.uniqueId8(),
          name: this.name,
          type: this.promotionType,
          text: this.text
        }]
      }
      this.$store.commit('onLoading', true)
      const res = await this.$store.dispatch('shop/putShopPreset', data)
      if (res && res.status === 200) {
        alert(this.locale.complete_save)
        this.$emit('reload', data.presetId)
        this.close()
      }
      this.$store.commit('onLoading', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 480px;
  }
}
.isRequired {
  .innerTitle {
    padding-left: 18px;
    &:after {
      content: "*";
      position: absolute;
      top: 0;
      left: 8px;
      color: $color-red;
    }
  }
}
</style>
